
<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-form ref="form">
      <v-layout wrap justify-center>
        <v-flex xs12 v-if="showCoverImage.length < 1">
          <v-img
            width="100%"
            height="400px"
            :src="require('../../../assets/images/no-image.png')"
            class="align-end"
          >
            <v-layout wrap justify-center pb-7>
              <v-flex xs6 lg3 align-self-center text-center>
                <CoverImageComp
                  @stepper="winStepper"
                  :height="'2118'"
                  :width="'8001'"
                  :heading="'Upload Cover Image'"
                  :componentType="'coverImage'"
                />
              </v-flex>
            </v-layout>
          </v-img>
        </v-flex>
        <v-flex xs12 v-else>
          <v-img
            width="100%"
            height="400px"
            :src="mediaURL + showCoverImage"
            class="align-end"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color=" #FDAC53"
                ></v-progress-circular>
              </v-row>
            </template>
            <v-layout wrap justify-center pb-7>
              <v-flex xs6 lg2 align-self-center text-center>
                <CoverImageComp
                  @stepper="winStepper"
                  :height="'2118'"
                  :width="'8001'"
                  :heading="'Upload Cover Image'"
                  :componentType="'coverImage'"
                />
              </v-flex>
            </v-layout>
          </v-img>
        </v-flex>

        <v-flex xs12 md11>
          <v-layout wrap justify-center>
            <v-flex xs6 text-center align-self-center py-5 class="RB clr"
              >EDIT SELLER PROFILE
            </v-flex>
            <!-- <v-flex xs5 md5 text-right py-5>
              <v-btn
                rounded
                color="#FEBD08"
                small
                class="RB"
                @click="profileUpload()"
                >SUBMIT
              </v-btn>
            </v-flex> -->
            <v-flex xs12 py-md-16 py-6>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-card color="#F5F5F5" tile flat>
                    <v-layout wrap pa-3 pa-lg-12>
                      <v-flex xs12 pb-7>
                        <span class="subhead" style="color: black"
                          >Upload Your Hive Video from youtube
                        </span>
                        <span style="color: #8b5454">Optional*</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="videoURL"
                          dense
                          solo
                          flat
                          label="Copy Video URL ….."
                        >
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12>
                        <v-divider> </v-divider>
                      </v-flex>
                      <v-flex xs12 text-center pt-12>
                        <input
                          id="gallery"
                          type="file"
                          hidden
                          accept="video/*"
                          @change="browseVideo"
                        />
                        <v-btn
                          @click="chooseVideo()"
                          width="70%"
                          tile
                          color="black"
                        >
                          <span
                            style="color: white; text-transform: none"
                            v-if="video.length <= 0"
                          >
                            or upload from storage
                          </span>
                          <span
                            v-else
                            style="color: white; text-transform: none"
                          >
                            Video Selected
                          </span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 px-sm-3 px-md-5>
                  <v-layout wrap pt-7>
                    <v-flex xs12 class="RB medium clr">Type Heading </v-flex>
                    <v-flex xs12>
                      <v-text-field :rules="[rules.required]" v-model="heading">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 class="RB medium2 clr"
                      >Type Video Description
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        v-model="description"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 py-5 class="RM clr"
              >Fill your Contact information
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[rules.required]"
                prepend-icon="mdi-account-outline"
                v-model="name"
                label="Name"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                type="number"
                :rules="[rules.required]"
                prepend-icon="mdi-phone-outline"
                v-model="phone"
                label="Phone"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[rules.email]"
                prepend-icon="mdi-at"
                v-model="datalist.email"
                label="Email"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[rules.required]"
                prepend-icon="mdi-map-marker-outline"
                v-model="address"
                label="Address"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                type="number"
                :rules="[rules.required]"
                prepend-icon="mdi-map-marker-outline"
                v-model="apiary"
                label="Number of Apiary"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[rules.required]"
                prepend-icon="mdi-map-marker-outline"
                v-model="displayName"
                label="displayName"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[rules.required]"
                prepend-icon="mdi-map-marker-outline"
                v-model="keeperDescription"
                label="Description"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 py-3>
              <span class="head">Select your location</span>
            </v-flex>
            <v-flex xs12>
              <div id="map44"></div>
            </v-flex>

            <v-flex xs12 py-12>
              <v-layout wrap justify-center>
                <v-flex xs12 text-center pb-4>
                  <span class="head">Upload to Hive Gallery</span>
                </v-flex>
                <v-flex xs12 sm6 md12 text-center v-if="flag">
                  <!-- <v-card height="300px" width="400px" color="#F5F5F5">
                    <v-file-input
                      multiple
                      type="file"
                      display-hidden
                      @change="browseToGallery"
                    ></v-file-input>
                    <v-layout
                      @click="chooseGallery()"
                      wrap
                      jystify-center
                      fill-height
                      class="align-center"
                    >
                      <v-flex xs12>
                        <div>
                          <v-icon> mdi-upload </v-icon>
                        </div>
                        <div class="RB clr">
                          Upload Multiple images from your storage
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card> -->
                  <!-- <galleryComp
                    @stepper="galleryStepper"
                    :details="urlgallery"
                    :sellerId="$route.query.seller"
                    :height="'5118'"
                    :width="'8001'"
                    :heading="'Upload Multiple images from your storage'"
                    :componentType="'coverImage'"
                    :photos="urlgallery"
                  /> -->
                  <galleryComp
                    @stepper="galleryStepper"
                    :photos="urlgallery"
                    :pageId="$route.query.seller"
                    :details="urlgallery"
                    :sellerId="$route.query.seller"
                    :height="'5118'"
                    :width="'8001'"
                    :heading="'Upload Images'"
                    :componentType="'coverImage'"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md5 text-center pb-5 pb-md-12>
              <v-btn tile width="100%" color="#FEBD08" @click="uploadToGallery">
                save</v-btn
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing">
</script>
<script>
import axios from "axios";
import CoverImageComp from "./singleImage.vue";
import galleryComp from "./multipleImages";
// import galleryComp from "./HM";
export default {
  data() {
    return {
      sp: [],
      timeout: 3000,
      video: [],
      videoData: new FormData(),
      urlgallery: [],
      url7: [],
      marker: [],
      msg: "",
      latt: 0,
      lonn: 0,
      maps: null,
      showSnackBar: false,
      showCoverImage: "",
      coverImage: "",
      coverData: new FormData(),
      appLoading: false,
      hiveGallery: [],
      gallery: new FormData(),
      heading: "",
      description: "",
      name: "",
      phone: "",
      email: "",
      address: "",
      apiary: "",
      videoURL: "",
      datalist: [],
      displayName: "",
      keeperDescription: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      imageFiles: [],
      imageArray: [],
      flag: true,
    };
  },
  components: {
    CoverImageComp,
    galleryComp,
  },
  mounted() {
    this.getMap();
    this.getUser();
  },

  methods: {
    winStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImage = window_data.selectedFiles;
        console.log("cover image is", this.coverImageFile);
        this.coverImageUpload();
      }
    },
    galleryStepper(window_data) {
      if (window_data.type == "image") {
        this.imageArray = window_data.imageArray;
        this.imageFiles.push(window_data.selectedFiles);
      } else if (window_data.type == "imageRemoval") {
        this.imageFiles.splice(window_data.removalItem, 1);
        this.imageArray = window_data.imageArray;
      } else if (window_data.type == "imageDeletion") {
        if (window_data.response.status) this.getUser();
      }
      // if (window_data.type == "coverImage") {
      //   this.hiveGallery.push(window_data.selectedFiles);
      //   this.urlgallery.push(window_data.selectedFiles);
      //   console.log("hive Gallery is", this.hiveGallery);
      //   console.log("url gallery is", this.urlgallery);
      // }
      if (window_data.getData) {
        this.getUser();
      }
    },
    // galleryStepper(window_data) {
    //   if (window_data.type == "coverImage") {
    //     this.hiveGallery.push(window_data.selectedFiles);
    //     this.urlgallery.push(window_data.selectedFiles);
    //     console.log("hive Gallery is", this.hiveGallery);
    //     console.log("url gallery is", this.urlgallery);
    //   }
    //   if (window_data.getData) {
    //     this.getUser();
    //   }
    // },
    getMap() {
      const gmap = new google.maps.Map(document.getElementById("map44"), {
        center: { lat: 20.5937, lng: 78.9629 },
        zoom: 5,
      });
      this.maps = gmap;
      google.maps.event.addListener(this.maps, "click", (e) => {
        this.mark(e);
      });
      this.marker = new google.maps.Marker({
        map: this.maps,
        title: "Hello World!",
      });
    },
    mark(event) {
      console.log("eve", event);
      this.latt = null;
      this.lonn = null;
      this.marker.setMap(null);
      this.latt = event.latLng.lat();
      this.lonn = event.latLng.lng();
      console.log("mark lt is", this.latt);
      console.log("mark ln is", this.lonn);

      this.marker = new google.maps.Marker({
        position: { lat: this.latt, lng: this.lonn },
        map: this.maps,
        title: "Hello World!",
      });
      console.log("marker =", this.latt);
    },
    unselect(value, item) {
      this.hiveGallery.splice(value, 1);
      this.urlgallery.splice(value, 1);
      this.sp = item;
      console.log("the image name is", this.sp);
      this.deleteFomGallery(item);
    },

    getUser() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/getdetails",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.datalist = response.data.data;
          if (response.data.data.sellerProfileId.name) {
            this.name = response.data.data.sellerProfileId.name;
          }
          if (response.data.data.sellerProfileId.name) {
            this.phone = response.data.data.sellerProfileId.phone;
          }
          if (response.data.data.sellerProfileId.address) {
            this.address = response.data.data.sellerProfileId.address;
          }
          if (response.data.data.sellerProfileId.apiaryCount) {
            this.apiary = response.data.data.sellerProfileId.apiaryCount;
          }
          if (response.data.data.sellerProfileId.heading) {
            this.heading = response.data.data.sellerProfileId.heading;
          }
          if (response.data.data.sellerProfileId.videoDescription) {
            this.description =
              response.data.data.sellerProfileId.videoDescription;
          }
          if (response.data.data.sellerProfileId.videoUrl) {
            this.videoURL = response.data.data.sellerProfileId.videoUrl;
          }
          if (response.data.data.sellerProfileId.displayName) {
            this.displayName = response.data.data.sellerProfileId.displayName;
          }
          if (response.data.data.sellerProfileId.description) {
            this.keeperDescription =
              response.data.data.sellerProfileId.description;
          }
          if (response.data.data.sellerProfileId.coverImage) {
            this.showCoverImage = response.data.data.sellerProfileId.coverImage;
            console.log("coverimage is", this.showCoverImage);
          }
          if (response.data.data.sellerProfileId.hiveGallery) {
            this.urlgallery = response.data.data.sellerProfileId.hiveGallery;
            console.log("urlGallery", this.urlgallery);
          }

          if (response.data.data.sellerProfileId.location) {
            this.marker.setMap(null);
            this.latt = response.data.data.sellerProfileId.location[1];
            this.lonn = response.data.data.sellerProfileId.location[0];
            this.marker = new google.maps.Marker({
              position: { lat: this.latt, lng: this.lonn },

              map: this.maps,
              title: "Hello World!",
            });

            console.log("marker is -", this.marker);
          }
          this.appLoading = false;
        } else {
          alert("failed to get email");
        }
      });
    },

    chooseCoverImage() {
      document.getElementById("coverImage").click();
    },
    chooseVideo() {
      document.getElementById("gallery").click();
    },
    browseVideo(file) {
      this.video = file.target.files[0];
      console.log("the video is", this.video);
    },
    browseToGallery(img) {
      for (let i = 0; i < img.length; i++) {
        this.hiveGallery.push(img[i]);
        this.url7.push(URL.createObjectURL(this.hiveGallery));
      }

      // this.hiveGallery = file.target.files;
      // console.log("gallery is", this.hiveGallery);
      console.log("hive gallary is=", this.hiveGallery);
      // this.uploadToGallery()
    },

    coverImageUpload() {
      this.coverData.append("uid", this.$route.query.seller);
      this.coverData.append("coverImage", this.coverImage);

      axios({
        method: "post",
        url: "/seller/coverImage/upload",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.coverData,
      }).then((response) => {
        if (response.data.status) {
          this.showCoverImage = response.data.coverImage;
          this.coverData = new FormData();
        } else {
          alert("failed to update cover image");
        }
      });
    },

    uploadToGallery() {
      this.flag = false;
      this.profileUpload();
      this.gallery.append("uid", this.$route.query.seller);
      if (this.imageArray.length > 0) {
        for (var i = 0; i < this.imageFiles.length; i++)
          this.gallery.append("hiveGallery", this.imageFiles[i]);

        // this.uploadMainImages(this.id);
      }
      // for (let i = 0; i < this.hiveGallery.length; i++) {
      //   this.gallery.append("hiveGallery", this.urlgallery[i]);
      // }
      this.appLoading = true;
      axios({
        method: "post",
        url: "/seller/hivegallery/upload",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.gallery,
      }).then((response) => {
        if (response.data.status) {
          this.flag = true;
          this.appLoading = false;
          this.showSnackBar = true;
          this.msg = " Successfully added to gallery ";
        } else {
          alert("failed");
        }
      });
    },
    deleteFomGallery(imgdata) {
      axios({
        method: "post",
        url: "/seller/hivegallery/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          uid: this.$route.query.seller,
          key: imgdata,
        },
      }).then((response) => {
        if (response.data.status) {
          console.log("the item is deleted from hive gallery");
        } else {
          console.log("the cod eis not workong sorryyy....");
        }
      });
    },
    profileUpload() {
      if (this.$refs.form.validate()) {
        this.appLoading = true;
        axios({
          method: "post",
          url: "/seller/profile/admin/update",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            id: this.$route.query.seller,
            heading: this.heading,
            videoDescription: this.description,
            videoUrl: this.videoURL,
            name: this.name,
            phone: this.phone,
            email: this.datalist.email,
            address: this.address,
            apiaryCount: this.apiary,
            displayName: this.displayName,
            description: this.keeperDescription,
            lat: this.latt,
            lon: this.lonn,
          },
        }).then((response) => {
          if (response.data.status) {
            if (this.videoURL.length > 0) {
              this.uploadVideo();
            } else {
              this.showSnackBar = true;
              this.msg = "profile Updated";
              this.getUser();
            }
          } else {
            this.showSnackBar = true;
            this.msg = "failed to update Profile";
          }
          this.appLoading = false;
        });
      }
    },
    uploadVideo() {
      this.videoData.append("uid", this.$route.query.seller);
      this.videoData.append("video", this.video);
      axios({
        method: "post",
        url: "/seller/video/upload",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.videoData,
      }).then((response) => {
        if (response.data.status) {
          this.appLoading = false;
          this.showSnackBar = true;
          this.msg = "profile Video Updated";
          this.getUser();
        } else {
          console.log("failed to upload video");
        }
      });
    },
  },
};
</script>

<style >
.center >>> input {
  text-align: center;
  font-family: robotobold;
}
.v-text-field >>> label {
  font-family: robotoregular;
  color: #d5d5d5;
}
#map44 {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>
